// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d6e7160e","355":"ceb7dba0","455":"b82591ec","977":"709e7fe1"}[chunkId] + ".chunk.js";
};